<template>
    <section class="aggregate-chat">
        <div class="aggregate-filter">
            <el-date-picker
                v-model="filter.date"
                size="mini"
                type="daterange"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-input
                v-model.trim="filter.customerName"
                size="mini"
                clearable
                placeholder="客户昵称"
                @keyup.enter.native="queryConversationList">
            </el-input>
            <el-input
                v-model.trim="filter.keyword"
                size="mini"
                clearable
                placeholder="消息关键词"
                @keyup.enter.native="queryAggregateChat">
            </el-input>
            <el-select v-model="filter.msgType" size="mini" placeholder="全部消息">
                <el-option label="全部消息" value=""></el-option>
                <el-option label="文本" value="text"></el-option>
                <el-option label="图片" value="image"></el-option>
                <el-option label="视频" value="video"></el-option>
                <el-option label="语音" value="voice"></el-option>
            </el-select>
            <el-button type="danger" size="mini" icon="el-icon-search" @click="queryAggregateChat">查询</el-button>
        </div>

        <div class="aggregate-body">
            <aside class="service-panel">
                <div class="panel-title">
                    <span>客服</span>
                    <span class="panel-count">{{serviceCount}} 人</span>
                </div>
                <el-input
                    v-model.trim="serviceKeyword"
                    size="mini"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="搜索客服">
                </el-input>
                <el-scrollbar class="service-scroll" v-loading="serviceLoading">
                    <button
                        v-for="item in filteredServiceList"
                        :key="item.id"
                        type="button"
                        class="service-item"
                        :class="{'service-item-on': selectedService.id===item.id}"
                        @click="selectService(item)">
                        <el-avatar :size="32" :src="item.avatar">{{getNameAbbr(item.name)}}</el-avatar>
                        <span class="service-name" :title="item.name">{{item.name}}</span>
                    </button>
                    <el-empty v-if="!serviceLoading && filteredServiceList.length===0" :image-size="50" description="暂无客服"></el-empty>
                </el-scrollbar>
            </aside>

            <section class="conversation-panel">
                <div class="panel-title">
                    <span>{{selectedService.name || '会话列表'}}</span>
                    <span class="panel-count">{{conversationTotal}} 个客户</span>
                </div>
                <el-scrollbar class="conversation-scroll" v-loading="conversationLoading">
                    <button
                        v-for="(item,index) in conversationList"
                        :key="getConversationKey(item,index)"
                        type="button"
                        class="conversation-item"
                        :class="{'conversation-item-on': isSameConversation(item)}"
                        @click="selectConversation(item)">
                        <el-avatar shape="square" :size="42" :src="item.avatar">{{getNameAbbr(item.name)}}</el-avatar>
                        <span class="conversation-info">
                            <strong :title="item.defineName || item.name">{{item.defineName || item.name || '未命名客户'}}</strong>
                            <span>微信昵称：{{item.name || '-'}}</span>
                            <time>{{item.maxMsgTime || '-'}}</time>
                        </span>
                    </button>
                    <div v-if="conversationList.length<conversationTotal" class="load-more">
                        <el-button type="text" size="mini" @click="queryConversationList(true)">加载更多会话</el-button>
                    </div>
                    <el-empty v-if="!conversationLoading && conversationList.length===0" :image-size="70" description="暂无会话"></el-empty>
                </el-scrollbar>
            </section>

            <section class="message-panel">
                <header class="message-header" v-if="selectedConversation.externalUserid">
                    <div>
                        <h3>{{selectedConversation.defineName || selectedConversation.name}}</h3>
                        <p>微信昵称：{{selectedConversation.name || '-'}} / 企微：{{getConversationServiceName()}} / 最后聊天：{{selectedConversation.maxMsgTime || '-'}}</p>
                    </div>
                    <el-tag size="mini" type="info">{{messageTotal}} 条记录</el-tag>
                </header>
                <el-scrollbar ref="messageScroll" class="message-scroll" v-loading="messageLoading">
                    <template v-if="selectedConversation.externalUserid">
                        <div v-if="messageList.length<messageTotal" class="load-more">
                            <el-button type="text" size="mini" @click="queryMessageList(true)">加载更早消息</el-button>
                        </div>
                        <div
                            v-for="(item,index) in messageList"
                            :key="item.id || index"
                            class="message-item"
                            :class="{'message-item-reverse': item.speakType!=2}">
                            <el-avatar :size="30" :src="getMessageAvatar(item)"></el-avatar>
                            <div class="message-main">
                                <div class="message-meta">
                                    <span v-if="item.speakType!=2">{{getServiceName(item.qyWeixinUserid)}}</span>
                                    <time>{{item.msgTime}}</time>
                                </div>
                                <div v-if="item.msgType==='text'" class="message-bubble"><SafeChatText :text="item.textContent" /></div>
                                <div v-else-if="item.msgType==='image' || item.msgType==='emotion'" class="message-media">
                                    <el-image :src="item.ossUrl" :preview-src-list="[item.ossUrl]" fit="cover"></el-image>
                                </div>
                                <div v-else-if="item.msgType==='voice'" class="message-bubble message-voice">[语音] {{item.amrTime || ''}}</div>
                                <div v-else-if="item.msgType==='video'" class="message-bubble">
                                    <a :href="item.ossUrl" target="_blank" rel="noopener noreferrer">查看视频</a>
                                </div>
                                <div v-else class="message-bubble">[{{getMessageTypeName(item.msgType)}}]</div>
                            </div>
                        </div>
                        <el-empty v-if="!messageLoading && messageList.length===0" :image-size="80" description="暂无聊天记录"></el-empty>
                    </template>
                    <el-empty v-else :image-size="80" description="请选择一个客户查看聊天记录"></el-empty>
                </el-scrollbar>
            </section>
        </div>
    </section>
</template>

<script>
import SafeChatText from '@/components/scrm/publicComponent/SafeChatText.vue'

const SERVICE_AVATAR = 'http://lechunbucket.oss-cn-beijing.aliyuncs.com/kboneMiniResource/public/lechun-logo.jpg'
const ALL_SERVICE_ID = '__all__'

export default {
    name: 'aggregateChat',
    components: { SafeChatText },
    props:{
        responsibleStaff:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        const currentDate = new Date()
        const currentMonth = currentDate.getMonth()
        const oneYearAgo = new Date(currentDate)
        oneYearAgo.setFullYear(oneYearAgo.getFullYear()-1)
        // 2026-07-11 coder(lq): 闰年 2 月 29 日回退一年时，默认到目标年份的 2 月最后一天。
        if(oneYearAgo.getMonth()!==currentMonth){
            oneYearAgo.setDate(0)
        }
        const today = currentDate.Format('yyyy-MM-dd')
        return {
            filter:{
                date:[oneYearAgo.Format('yyyy-MM-dd'),today],
                customerName:'',
                keyword:'',
                msgType:''
            },
            serviceKeyword:'',
            serviceList:[],
            selectedService:{},
            conversationList:[],
            selectedConversation:{},
            messageList:[],
            conversationTotal:0,
            messageTotal:0,
            conversationPage:1,
            messagePage:1,
            serviceLoading:false,
            conversationLoading:false,
            messageLoading:false
        }
    },
    computed:{
        serviceCount(){
            return this.serviceList.filter(item=>!item.isAll).length
        },
        filteredServiceList(){
            if(!this.serviceKeyword){
                return this.serviceList
            }
            return this.serviceList.filter(item=>item.isAll || (item.name || '').indexOf(this.serviceKeyword)>-1)
        }
    },
    watch:{
        responsibleStaff:{
            immediate:true,
            deep:true,
            handler(list){
                this.applyResponsibleStaff(list)
            }
        }
    },
    methods:{
        applyResponsibleStaff(list){
            const previousId = this.selectedService.id
            const serviceList = (Array.isArray(list) ? list : []).map(item=>({
                ...item,
                id:item.qyWeixinUserid,
                name:item.distributorName || item.qyWeixinUserid
            })).filter(item=>item.id)
            this.serviceList = serviceList.length ? [{id:ALL_SERVICE_ID,name:'全部',isAll:true}].concat(serviceList) : []
            const selected = this.serviceList.find(item=>item.id===previousId)
            if(selected){
                this.selectedService = selected
                return
            }
            this.selectedService = {}
            this.selectedConversation = {}
            this.conversationList = []
            this.messageList = []
            this.conversationTotal = 0
            this.messageTotal = 0
            if(this.serviceList.length){
                this.selectService(this.serviceList[0])
            }
        },
        // 2026-07-11 coder(lq): 聚合页按“客服-客户-消息”逐级加载，复用现有接口，避免一次请求拉取全部聊天记录。
        selectService(item){
            this.selectedService = item
            this.selectedConversation = {}
            this.messageList = []
            this.queryConversationList()
        },
        queryAggregateChat(){
            if(!this.selectedService.id){
                this.$message.warning('请先选择客服')
                return
            }
            this.queryConversationList()
        },
        queryConversationList(loadMore){
            if(!this.selectedService.id){
                return
            }
            this.conversationLoading = true
            if(loadMore){
                this.conversationPage++
            }else{
                this.conversationPage = 1
                this.selectedConversation = {}
                this.messageList = []
            }
            const date = this.filter.date || ['','']
            // 2026-07-12 coder(lq): “全部”批量查会话，进入详情后仍使用会话自身企微 ID，避免同一客户跨企微串聊。
            const serviceIds = this.selectedService.isAll
                ? this.serviceList.filter(item=>!item.isAll).map(item=>item.id)
                : [this.selectedService.id]
            const params = {
                currentPage:this.conversationPage,
                pageSize:50,
                qyWeixinUserid:this.selectedService.isAll ? '' : this.selectedService.id,
                qyWeixinUserids:this.selectedService.isAll ? serviceIds.join(',') : '',
                name:this.filter.customerName,
                sdate:date[0] || '',
                edate:date[1] || ''
            }
            this.$apiGet('lechun-bi/generateScene/getQwChatCustomerList', params).then(res=>{
                const list = res.list || []
                this.conversationList = loadMore ? this.conversationList.concat(list) : list
                this.conversationTotal = res.total || 0
                if(!loadMore && this.conversationList.length){
                    this.selectConversation(this.conversationList[0])
                }
            }).finally(()=>{
                this.conversationLoading = false
            })
        },
        selectConversation(item){
            this.selectedConversation = item
            this.queryMessageList()
        },
        queryMessageList(loadMore){
            if(!this.selectedConversation.externalUserid){
                return
            }
            this.messageLoading = true
            this.messagePage = loadMore ? this.messagePage+1 : 1
            const date = this.filter.date || ['','']
            const qyWeixinUserid = this.selectedConversation.qyWeixinUserid || this.selectedService.id
            const params = {
                currentPage:this.messagePage,
                pageSize:50,
                qyWeixinUserid,
                externalUserid:this.selectedConversation.externalUserid,
                sdate:date[0] || '',
                edate:date[1] || '',
                content:this.filter.keyword,
                msgType:this.filter.msgType
            }
            this.$apiGet('lechun-bi/generateScene/getQwChatList', params).then(res=>{
                const list = res.list || []
                this.messageList = loadMore ? list.concat(this.messageList) : list
                this.messageTotal = res.total || 0
                if(!loadMore){
                    this.$nextTick(this.scrollMessageBottom)
                }
            }).finally(()=>{
                this.messageLoading = false
            })
        },
        scrollMessageBottom(){
            const scrollbar = this.$refs.messageScroll
            if(scrollbar && scrollbar.wrap){
                scrollbar.wrap.scrollTop = scrollbar.wrap.scrollHeight
            }
        },
        getNameAbbr(name){
            return name ? name.slice(-2) : '-'
        },
        getConversationKey(item,index){
            return item.qyWeixinUserid && item.externalUserid
                ? item.qyWeixinUserid+'-'+item.externalUserid
                : index
        },
        isSameConversation(item){
            return this.selectedConversation.externalUserid===item.externalUserid
                && this.selectedConversation.qyWeixinUserid===item.qyWeixinUserid
        },
        getServiceName(qyWeixinUserid){
            const service = this.serviceList.find(item=>item.id===qyWeixinUserid)
            return service ? service.name : (qyWeixinUserid || '未知企微')
        },
        getConversationServiceName(){
            return this.getServiceName(this.selectedConversation.qyWeixinUserid)
        },
        getMessageAvatar(item){
            return item.speakType==2 ? item.avatar : SERVICE_AVATAR
        },
        getMessageTypeName(type){
            const names = {weapp:'小程序',file:'文件',link:'链接',location:'位置',revoke:'撤回消息'}
            return names[type] || type || '未知消息'
        },
        // 2026-07-11 coder(lq): 关键词进入正则前必须转义，防止特殊字符导致页面搜索报错。
        highlightKeyword(text){
            if(!text || !this.filter.keyword){
                return text
            }
            const keyword = this.filter.keyword.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')
            return text.replace(new RegExp(keyword,'gi'), value=>'<span class="keyword-highlight">'+value+'</span>')
        }
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.aggregate-chat{
    height:100%;
    display:flex;
    flex-direction:column;
    color:#333;
    .aggregate-filter{
        min-height:58px;
        padding:12px 14px;
        box-sizing:border-box;
        display:flex;
        align-items:center;
        gap:10px;
        border-bottom:1px solid #ebeef5;
        background:#fff;
        .el-date-editor{width:280px;}
        .el-input{width:190px;}
        .el-select{width:130px;.el-input{width:100%;}}
    }
    .aggregate-body{flex:1;min-height:0;display:flex;background:#f5f7fa;}
    .panel-title{height:42px;display:flex;align-items:center;justify-content:space-between;font-weight:600;font-size:14px;}
    .panel-count{font-size:12px;color:#909399;font-weight:normal;}
    .service-panel{width:150px;padding:0 10px;background:#f5f5f5;border-right:1px solid #e4e7ed;box-sizing:border-box;}
    .service-scroll{height:calc(100% - 84px);margin-top:8px;}
    .service-item{width:100%;border:0;background:transparent;border-radius:4px;padding:7px 5px;margin-bottom:4px;display:flex;align-items:center;cursor:pointer;color:#606266;text-align:left;}
    .service-item:hover{background:#e8f5f3;}
    .service-item-on{background:#209e91!important;color:#fff;}
    .service-name{margin-left:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .conversation-panel{width:300px;background:#fff;border-right:1px solid #e4e7ed;box-sizing:border-box;}
    .conversation-panel .panel-title{padding:0 14px;border-bottom:1px solid #ebeef5;}
    .conversation-scroll{height:calc(100% - 43px);}
    .conversation-item{width:100%;min-height:82px;padding:12px 14px;border:0;border-bottom:1px solid #ebeef5;background:#fff;display:flex;align-items:center;text-align:left;cursor:pointer;box-sizing:border-box;}
    .conversation-item:hover{background:#f3faf9;}
    .conversation-item-on{background:rgba(32,158,145,.12);box-shadow:inset 3px 0 #209e91;}
    .conversation-info{display:flex;min-width:0;flex:1;margin-left:10px;flex-direction:column;line-height:20px;color:#909399;font-size:12px;}
    .conversation-info strong{color:#303133;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .conversation-info time{text-align:right;color:#b5b9c0;font-size:11px;}
    .message-panel{flex:1;min-width:0;background:#fff;display:flex;flex-direction:column;}
    .message-header{height:72px;padding:0 18px;border-bottom:1px solid #ebeef5;display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;}
    .message-header h3,.message-header p{margin:0;}.message-header h3{font-size:16px;}.message-header p{margin-top:8px;font-size:12px;color:#909399;}
    .message-scroll{flex:1;min-height:0;padding:15px 20px;box-sizing:border-box;background:#fafafa;}
    .message-scroll>.el-scrollbar__wrap{overflow-x:hidden;}
    .message-item{display:flex;align-items:flex-start;margin-bottom:18px;}
    .message-main{max-width:72%;margin-left:9px;display:flex;flex-direction:column;align-items:flex-start;}
    .message-meta{display:flex;align-items:center;gap:6px;font-size:11px;color:#a5a8ad;margin-bottom:5px;}
    .message-meta span{color:#606266;}
    .message-bubble{padding:9px 12px;border:1px solid #ebeef5;border-radius:3px;background:#fff;line-height:20px;font-size:13px;white-space:pre-wrap;word-break:break-all;box-shadow:0 1px 2px rgba(0,0,0,.03);}
    .message-item-reverse{flex-direction:row-reverse;}.message-item-reverse .message-main{margin:0 9px 0 0;align-items:flex-end;}.message-item-reverse .message-bubble{background:#dff4f0;border-color:#c7e8e2;}
    .message-media .el-image{width:120px;height:120px;border-radius:4px;}
    .message-voice{min-width:100px;}
    .keyword-highlight{color:#e50011;background:#fff28a;}
    .load-more{text-align:center;padding:5px 0;}
    .el-empty{padding-top:45px;}
}
</style>
